export default __webpack_public_path__ + "static/media/2t.aa12396d.jpg";